import { Box, IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { JuvareLogo } from '../../JuvareLogo';
import { useCommonWebTranslation } from '../../hooks';
export const JuvareIconButton = (props) => {
    const { t } = useCommonWebTranslation();
    return (React.createElement(Tooltip, { title: t('globalHeader.otherJuvareSolutions') },
        React.createElement(IconButton, { size: 'large', href: props.href, onClick: props.onClick, "data-test": 'juvare-button' },
            React.createElement(Box, { sx: { width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                React.createElement(Box, { sx: { display: 'flex' } },
                    React.createElement(JuvareLogo, { size: 'lg' }))))));
};
